import { render, staticRenderFns } from "./P2PArbitratorsListFilters.vue?vue&type=template&id=de2b0974&"
import script from "./P2PArbitratorsListFilters.vue?vue&type=script&lang=js&"
export * from "./P2PArbitratorsListFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports